module.exports = __webpack_public_path__ + "img/qrcodebg.f8f7bd38.png";